import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { HttpService } from "./http.service";
import { Configuration } from '../configurations/shared.config';
import { Observable } from "rxjs";

@Injectable()

export class OnlineVehiclesService {

	constructor(private http: Http, private httpService: HttpService) { }

	getOnlineVehicles(loader: boolean = true): Observable<any> {
		return this.httpService.get(Configuration.urls.webApiEndpoint + Configuration.urls.GetFreeVehiclesCount, null, loader).map(res => res.json());
	}
	getGetFreeVehiclesDetails(loader: boolean = true): Observable<any> {
		return this.httpService.get(Configuration.urls.webApiEndpoint + Configuration.urls.GetFreeVehiclesDetails, null, loader).map(res => res.json());
	}
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/onlineVehicles.service.ts